import { Box } from '@cast/design-system';
import { ResourceMetricBox } from '../metric-box/ResourceMetricBox';

type Metrics<T extends string> = Partial<Record<T, number | null | undefined>>;

type Props<T extends string> = {
  unit: 'GiB' | 'CPU' | '%';
  secondaryMetricsBoxesUnit?: 'GiB' | 'CPU' | '%';
  summary?: Metrics<T>;
  metricsBoxes: Array<T>;
  titleMap: Record<T, string>;
  colorMap: Record<T, string>;
  secondaryMetricsBoxes?: Array<T>;
  tight?: boolean;
  isMetricDisabled: (metric: T) => boolean;
  toggleMetricsBox?: (metric: T) => void;
  fullWidth?: boolean;
};

// todo:task simplify implementation, possible obsolete implementation from previous needs
export const UsageMetricsBoxes = <T extends string>({
  unit,
  summary,
  metricsBoxes,
  titleMap,
  colorMap,
  secondaryMetricsBoxes = [],
  tight = false,
  isMetricDisabled,
  toggleMetricsBox = () => {},
  secondaryMetricsBoxesUnit,
  fullWidth = false,
}: Props<T>) => {
  const renderMetrics = (keys: Array<T>, internalUnit?: 'GiB' | 'CPU' | '%') =>
    keys.map((key) => {
      const value = summary?.[key];

      return (
        <ResourceMetricBox
          key={key}
          testId={`usage-metric-${key}`}
          dataKey={key}
          value={value}
          unit={internalUnit}
          colorMap={colorMap}
          titleMap={titleMap}
          toggleMetric={toggleMetricsBox}
          isMetricDisabled={isMetricDisabled}
        />
      );
    });

  const gridTemplateColumns = secondaryMetricsBoxes.length
    ? `repeat(${metricsBoxes.length}, 1fr) auto repeat(${secondaryMetricsBoxes.length}, 1fr)`
    : undefined;

  return (
    <Box
      width={fullWidth ? '100%' : 'auto'}
      display="grid"
      columnGap={12}
      {...(gridTemplateColumns
        ? { gridTemplateColumns }
        : tight
        ? { gridAutoFlow: 'column', justifyContent: 'flex-start' }
        : { gridAutoFlow: 'column', gridAutoColumns: '1fr' })}
    >
      {renderMetrics(metricsBoxes, unit)}
      {!!secondaryMetricsBoxes.length &&
        renderMetrics(secondaryMetricsBoxes, secondaryMetricsBoxesUnit)}
    </Box>
  );
};
